import { Component, Input, OnInit, inject, DestroyRef, Output, EventEmitter, ViewChild, AfterViewInit} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDivider } from '@angular/material/divider';
import { AuditColumns } from 'src/app/models/instance/audit-column';
import { FilterItem } from 'src/app/models/filter/filter-item';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IconsModule } from "src/app/icons/icons.module";
import { FormGroup, FormBuilder, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-audit-filter',
  templateUrl: './audit-filter.component.html',
  styleUrl: './audit-filter.component.scss',
  standalone: true,
  imports: [TranslocoModule, MatDivider, IconsModule, MatInputModule, MatSelectModule, ReactiveFormsModule, CommonModule, FormsModule],
})
export class AuditFilterComponent implements OnInit, AfterViewInit {
   @Output() filtersApplied = new EventEmitter<any>();
   @Input() openDropdown?: 'initiatedBy' | 'action' | 'tenantId' | 'status';
   @ViewChild('userSelect') userSelect!: MatSelect;
   @ViewChild('actionSelect') actionSelect!: MatSelect;
   @ViewChild('tenantSelect') tenantSelect!: MatSelect;
   @ViewChild('statusSelect') statusSelect!: MatSelect;

   private destroyRef = inject(DestroyRef);
   filterForm: FormGroup;
   selected: any;
   allColumns;
   isMultipleTenant = false;
   dataListTenant = [];
   tenantMaxLimit = false;
   columnFilterItems: FilterItem<string>[] = [];

  @Input() title: string;
  @Input() subtitle: string;
  @Input() status: any;
  @Input() tenant: any;
  @Input() name: any;
  @Input() action: any;
  @Input() data: any;
  @Input() initiatedBy: any;
  @Input() auditData: any;
  @Input() filteredColumns: string;
  @Input() isMultiSelect = false;

    dbStatusList = [];
    dataListAction = [];
    dataListInitiate = [];
    dataListStatus = '';
    filteredActions: { value: string; selected?: boolean }[] = [];
    filteredUser: { value: string; selected?: boolean }[] = [];
    filteredTenant: { value: string; selected?: boolean }[] = [];
    filteredStatus: { value: string; label?: string; selected?: boolean }[] = []; 
    searchActionValue = '';
    searchUserValue = '';
    searchTenantValue = '';
    searchStatusValue = '';
    selectedAction = [];
    selectedUser = [];
    selectedTenant = [];
    selectedStatus = [];
    stateClear = false;
    tempSelectedUser: string[] = [];
    tempSelectedAction: string[] = [];
    tempSelectedTenant: string[] = [];
    tempSelectedStatus: string[] = [];
    userApplied = false;
    actionApplied = false;
    tenantApplied = false;
    statusApplied = false;
    
    masterSelectedUser: Set<string> = new Set();
    masterSelectedAction: Set<string> = new Set();
    masterSelectedTenant: Set<string> = new Set();
    masterSelectedStatus: Set<string> = new Set();
    
  constructor(public sidenavService: SidenavService, private dialog: MatDialog, private formBuilder: FormBuilder) { 
  }

  ngOnInit(): void {    
    if (this.name === 'Audit Dashboard') {
      this.allColumns = AuditColumns;
      this.isMultipleTenant = true;
    }
    this.configureColumnFilterItems(false);
    const formConfig: any = {
        initiatedBy: [''],
        action: [''],
        tenant: [''],
        status: ['']
      };
      this.filterForm = this.formBuilder.group(formConfig);

this.dataListInitiate = this.initiatedBy?.filter(initiated => initiated.selected).map(initiated => initiated.value) || [];
this.dataListAction = this.action?.filter(actions => actions.selected).map(actions => actions.value) || [];
this.dataListTenant = this.tenant?.filter(tenantId => tenantId.selected).map(tenantId => tenantId.value) || [];
this.dbStatusList = this.status?.filter(statuses=> statuses.selected).map(statuses => statuses.value) || [];

this.selectedUser = [...this.dataListInitiate];
this.tempSelectedUser = [...this.selectedUser];
this.selectedAction = [...this.dataListAction];
this.tempSelectedAction = [...this.selectedAction];
this.selectedTenant = [...this.dataListTenant];
this.tempSelectedTenant = [...this.selectedTenant];
this.selectedStatus = [...this.dbStatusList];
this.tempSelectedStatus = [...this.selectedStatus];

this.filteredActions = [...(this.action || [])];
this.filteredUser = [...(this.initiatedBy || [])];
this.filteredTenant = [...(this.tenant || [])];
this.filteredStatus = [...(this.status || [])];

  this.filterForm.patchValue({
    initiatedBy: this.dataListInitiate,
    action: this.dataListAction,
    tenant: this.dataListTenant,
    status: this.dbStatusList
  }, { emitEvent: false });

      this.selectOptionsStatus();

    this.sidenavService.filterOutsideClick.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data === 'clear') {
          this.clearData();
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const map: Record<string, MatSelect | undefined> = {
        initiatedBy: this.userSelect,
        action: this.actionSelect,
        tenantId: this.tenantSelect,
        status: this.statusSelect,
      };
      map[this.openDropdown || '']?.open();
    }, 350);
  }

  /* Reorders the provided options array and returns the updated list. */
  private reorderOptions(options: any[]): any[] {
  if (!options) return [];
  return [...options].sort((a, b) => {
    if (a.selected === b.selected) {
      return a.value.localeCompare(b.value);
    }
    return a.selected ? -1 : 1;
  });
}

/* Clears the component data */
clearData(): void {
   if (this.tenant?.length) {
    if (this.isMultipleTenant) {
      this.dataListTenant?.forEach(selectedItem => {
        const tenantItem = this.tenant.find(t => t?.value === selectedItem);
        if (tenantItem) {
          tenantItem.selected = false;
        }
      });
    } else {
      this.tenant.forEach(item => {
        if (item?.value === this.dataListTenant) {
          item.selected = false;
        }
      });
    }
  }

  if (this.status?.length) {
    this.dbStatusList?.forEach(selectedItem => {
      const statusItem = this.status.find(s => s?.value === selectedItem);
      if (statusItem) {
        statusItem.selected = false;
      }
    });
  }

  if (this.action?.length) {
    this.dataListAction?.forEach(selectedItem => {
      const actionItem = this.action.find(a => a?.value === selectedItem);
      if (actionItem) {
        actionItem.selected = false;
      }
    });
  }

  if (this.initiatedBy?.length) {
    this.dataListInitiate?.forEach(selectedItem => {
      const userItem = this.initiatedBy.find(u => u?.value === selectedItem);
      if (userItem) {
        userItem.selected = false;
      }
    });
  }
  
  this.dataListTenant = [];
  this.dbStatusList = [];
  this.dataListAction = [];
  this.dataListInitiate = [];
}

/* Applies filtering on the provided data array based on filterValue */
  applyFilter(reset?): void {
  const filters = {
    initiatedBy: this.selectedUser || [],
    action: this.selectedAction || [],
    tenant: this.selectedTenant || [],
    status: this.selectedStatus || []
  };

  this.filtersApplied.emit(filters);
  this.sidenavService.closeRightSidenav(filters);
}

/* Selects a tenant option and updates the component state accordingly */
  selectOptionsTenant(item?): void {
    if(this.isMultipleTenant) {
      if(item) {
        item.selected = !item.selected;
        const selectedTenants = this.tenant.filter(item=> item.selected == true);
        if (selectedTenants.length <= 5 ) {
          this.dataListTenant = [];
          for (const items of this.tenant) {
            if (items.selected) {
              this.dataListTenant.push(items.value);
            }
          }
          this.dataListTenant = [...new Set(this.dataListTenant)];
          this.tenantMaxLimit = selectedTenants.length === 5? true: false;
        } else {
          item.selected = !item.selected;
          this.tenantMaxLimit = true;
        }
      }
    } else {
      if(this.tenant) {
        for (const items of this.tenant) {
          if (items.selected) {
            items.selected = false;
          }
        }
      }
      if(item) {
      item.selected = !item.selected;
      this.dataListTenant= item.value;
      };
    }
  }

  /* Selects a user option and updates the component state accordingly */
selectOptionsInitiate(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.dataListInitiate = [];
      for (const items of this.initiatedBy) {
        if (items.selected) {
          this.dataListInitiate.push(items.value);
        }
      }
      this.dataListInitiate = [...new Set(this.dataListInitiate)];
    }
  }

  /* Selects a action option and updates the component state accordingly */
  selectOptionsAction(item?): void {
    if (item) {
      item.selected = !item.selected;
      this.dataListAction = [];
      for (const items of this.action) {
        if (items.selected) {
          this.dataListAction.push(items.value);
        }
      }
      this.dataListAction = [...new Set(this.dataListAction)];
      this.dataListAction?.filter((item) => {
      this.dataListAction.forEach(selectedItem => {
        this.action.find((item)=> item.value === selectedItem);
      })
    });
    }
  }

  /* Selects a status option and updates the component state accordingly */
  selectOptionsStatus(item?): void {
    if (this.isMultiSelect) {
      if (item) {
        item.selected = !item.selected;
        this.dbStatusList = [];
        for (const items of this.status) {
          if (items.selected) {
            this.dbStatusList.push(items.value);
          }
        }
        this.dbStatusList = [...new Set(this.dbStatusList)];
      }
    } else {
      this.dataListStatus = '';
      if(this.status) {
        for (const items of this.status) {
          if (items.selected) {
            items.selected = false;
          }
        }
      }
      if(item) {
      item.selected = !item.selected;
      this.dataListStatus = item.value;
      };
    }
  }

  /* Toggle the presence of a User value in the temporary selection set. */
  toggleUserSelection(value: string): void {
  if (this.masterSelectedUser.has(value)) {
    this.masterSelectedUser.delete(value);
  } else {
    this.masterSelectedUser.add(value);
  }
  this.tempSelectedUser = Array.from(this.masterSelectedUser);
}

/* Toggle the presence of a Action value in the temporary selection set. */
toggleActionSelection(value: string): void {
  if (this.masterSelectedAction.has(value)) {
    this.masterSelectedAction.delete(value);
  } else {
    this.masterSelectedAction.add(value);
  }
  this.tempSelectedAction = Array.from(this.masterSelectedAction);
}

/* Toggle the presence of a Tenant value in the temporary selection set. */
toggleTenantSelection(value: string): void {
  if (this.masterSelectedTenant.has(value)) {
    this.masterSelectedTenant.delete(value);
  } else {
    this.masterSelectedTenant.add(value);
  }
  this.tempSelectedTenant = Array.from(this.masterSelectedTenant);
}

/* Toggle the presence of a Status value in the temporary selection set. */
toggleStatusSelection(value: string): void {
  if (this.masterSelectedStatus.has(value)) {
    this.masterSelectedStatus.delete(value);
  } else {
    this.masterSelectedStatus.add(value);
  }
  this.tempSelectedStatus = Array.from(this.masterSelectedStatus);
}

/* Handle selection change for the User dropdown. */
onUserOptionSelection(event: any, value: string): void {
  if (!this.tempSelectedUser) {
    this.tempSelectedUser = [];
  }
  if (event && event.source && event.source.selected) {
    if (!this.tempSelectedUser.includes(value)) {
      this.tempSelectedUser.push(value);
    }
  } else {
    this.tempSelectedUser = this.tempSelectedUser.filter(v => v !== value);
  }
}

/* Handle selection change for the Action dropdown. */
onActionOptionSelection(event: any, value: string): void {
  if (!this.tempSelectedAction) {
    this.tempSelectedAction = [];
  }
  if (event && event.source && event.source.selected) {
    if (!this.tempSelectedAction.includes(value)) {
      this.tempSelectedAction.push(value);
    }
  } else {
    this.tempSelectedAction = this.tempSelectedAction.filter(v => v !== value);
  }
}

/* Handle selection change for the Tenant dropdown. */
onTenantOptionSelection(event: any, value: string): void {
  if (!this.tempSelectedTenant) {
    this.tempSelectedTenant = [];
  }
  if (event && event.source && event.source.selected) {
    if (!this.tempSelectedTenant.includes(value)) {
      this.tempSelectedTenant.push(value);
    }
  } else {
    this.tempSelectedTenant = this.tempSelectedTenant.filter(v => v !== value);
  }
}

/* Handle selection change for the Status dropdown. */
onStatusOptionSelection(event: any, value: string): void {
  if (!this.tempSelectedStatus) {
    this.tempSelectedStatus = [];
  }
  if (event && event.source && event.source.selected) {
    if (!this.tempSelectedStatus.includes(value)) {
      this.tempSelectedStatus.push(value);
    }
  } else {
    this.tempSelectedStatus = this.tempSelectedStatus.filter(v => v !== value);
  }
}

  /* Triggered when the action dropdown is opened or closed */
onActionDropdownOpen(opened: boolean): void {
if (opened) {
    this.tempSelectedAction = [...this.selectedAction];
    this.actionApplied = false;
    this.filteredActions = this.reorderOptions(this.filteredActions);
  }
  else {
    if (!this.actionApplied) {
      this.tempSelectedAction = [...(this.selectedAction || [])];
    }
  }
}

/* Triggered when the user dropdown is opened or closed */
onUserDropdownOpen(opened: boolean): void {
if (opened) {
    this.tempSelectedUser = [...this.selectedUser];
    this.userApplied = false;
    this.filteredUser = this.reorderOptions(this.filteredUser);
  }
  else {
    if (!this.userApplied) {
      this.tempSelectedUser = [...(this.selectedUser || [])];
    }
  }
}

/* Triggered when the tenant dropdown is opened or closed */
onTenantDropdownOpen(opened: boolean): void {
if (opened) {
    this.tempSelectedTenant = [...this.selectedTenant];
    this.tenantApplied = false;
    this.filteredTenant = this.reorderOptions(this.filteredTenant);
  }
  else {
    if (!this.tenantApplied) {
      this.tempSelectedTenant = [...(this.selectedTenant || [])];
    }
  }
}

/* Triggered when the status dropdown is opened or closed */
onStatusDropdownOpen(opened: boolean): void {
if (opened) {
    this.tempSelectedStatus = [...this.selectedStatus];
    this.statusApplied = false;

     this.filteredStatus = this.filteredStatus.map(opt => ({...opt,
      selected: this.selectedStatus.includes(opt.value)
    }));
    this.filteredStatus = this.reorderOptions(this.filteredStatus);
  }
  else {
    if (!this.statusApplied) {
      this.tempSelectedStatus = [...(this.selectedStatus || [])];
    }
  }}

  /* Toggles the temporary user state based on the given value */
toggleTempUser(value: string): void {
  if (this.tempSelectedUser.includes(value)) {
    this.tempSelectedUser = this.tempSelectedUser.filter(v => v !== value);
  } else {
    this.tempSelectedUser = [...this.tempSelectedUser, value];
  }
}

/* Updates the search state and filters user results based on the input */
searchUserChanged(search: string): void {
  if (!search?.trim()) {
    this.filteredUser = [...this.initiatedBy];
  } else {
    const lower = search.toLowerCase();
    this.filteredUser = this.initiatedBy.filter(a =>
      a.value?.toLowerCase().includes(lower)
    );
  }
}

/* Updates the search state and filters action results based on the input */
searchActionChanged(search: string): void {
  if (!search?.trim()) {
    this.filteredActions = [...this.action];
  } else {
    const lower = search.toLowerCase();
    this.filteredActions = this.action.filter(a =>
      a.value?.toLowerCase().includes(lower)
    );
  }
}

/* Updates the search state and filters tenant results based on the input */
searchTenantChanged(search: string): void {
  if (!search?.trim()) {
    this.filteredTenant = [...this.tenant];
  } else {
    const lower = search.toLowerCase();
    this.filteredTenant = this.tenant.filter(a =>
      a.value?.toLowerCase().includes(lower)
    );
  }
}

/* Updates the search state and filters status results based on the input */
searchStatusChanged(search: string): void {
  if (!search?.trim()) {
    this.filteredStatus = [...this.status];
  } else {
    const lower = search.toLowerCase();
    this.filteredStatus = this.status.filter(a =>
      a.value?.toLowerCase().includes(lower)
    );
  }
}

/* Clears all selected actions from the dropdown or list */
clearAllActions(event: MouseEvent, select: any): void {
  event.stopPropagation();
  this.tempSelectedAction = [];
  this.masterSelectedAction.clear();
  if (select && select.options) {
    select.options.forEach((option: any) => option.deselect());
  }
  this.stateClear = true;
}

/* Clears all selected user from the dropdown or list */
clearAllUser(event: MouseEvent, select: MatSelect | any): void {
   event.stopPropagation();
  this.tempSelectedUser = [];
  this.masterSelectedUser.clear();
  if (select && select.options) {
    select.options.forEach((opt: any) => opt.deselect());
  }
  this.stateClear = true;
}

/* Clears all selected tenant from the dropdown or list */
clearAllTenant(event: MouseEvent, select: any): void {
 event.stopPropagation();
  this.tempSelectedTenant = [];
  this.masterSelectedTenant.clear();
  if (select && select.options) {
    select.options.forEach((option: any) => option.deselect());
  }
  this.stateClear = true;
}

/* Clears all selected status from the dropdown or list */
clearAllStatus(event: MouseEvent, select: any): void {
 event.stopPropagation();
  this.tempSelectedStatus = [];
  this.masterSelectedStatus.clear();
  if (select && select.options) {
    select.options.forEach((option: any) => option.deselect());
  }
  this.stateClear = true;
}

/* Closes the user dropdown menu */
closeUserDropdown(select: MatSelect | any): void {
  this.tempSelectedUser = [...this.selectedUser];
  this.searchUserValue = '';
  this.filteredUser = [...this.initiatedBy];
  select.close();
}

/* Handles the event when the user dropdown is closed */
onUserDropdownClosed(): void {
  if (!this.userApplied) {
    this.tempSelectedUser = [...(this.selectedUser || [])];
  }
  this.searchUserValue = '';
  this.filteredUser = [...this.initiatedBy];
}

/* Closes the action dropdown menu */
closeActionDropdown(select: MatSelect | any): void {
  this.tempSelectedAction = [...this.selectedAction];
  if (this.searchActionValue) {
    this.searchActionValue = '';
  }
  select.close();
}

/* Handles the event when the action dropdown is closed */
onActionDropdownClosed(): void {
  if (!this.actionApplied) {
    this.tempSelectedAction = [...(this.selectedAction || [])];
  }
  this.searchActionValue = '';
  this.filteredActions = [...this.action];
}

/* Closes the tenant dropdown menu */
closeTenantDropdown(select: MatSelect | any): void {
  this.tempSelectedTenant = [...this.selectedTenant];
  if (this.searchTenantValue) {
    this.searchTenantValue = '';
  }
  select.close();
}

/* Handles the event when the tenant dropdown is closed */
onTenantDropdownClosed(): void {
  if (!this.tenantApplied) {
    this.tempSelectedTenant = [...(this.selectedTenant || [])];
  }
  this.searchTenantValue = '';
  this.filteredTenant = [...this.tenant];
}

/* Closes the status dropdown menu */
closeStatusDropdown(select: MatSelect | any): void {
  this.tempSelectedStatus = [...this.selectedStatus];
  if (this.searchStatusValue) {
    this.searchStatusValue = '';
  }
  select.close();
}

/* Handles the event when the status dropdown is closed */
onStatusDropdownClosed(): void {
  if (!this.statusApplied) {
    this.tempSelectedStatus = [...(this.selectedStatus || [])];
  }
  this.searchStatusValue = '';
  this.filteredStatus = [...this.status];
}

/* Handles applying the currently selected user from the dropdown or list */
applyUserSelection(select: any): void {
  this.selectedUser = [...(this.tempSelectedUser || [])];
  this.dataListInitiate = [...this.selectedUser];
  this.userApplied = true;
  this.stateClear = true;
  select.close();
}

/* Handles applying the currently selected action from the dropdown or list */
applyActionSelection(select: any): void {
  this.selectedAction = [...(this.tempSelectedAction || [])];
  this.dataListAction = [...this.selectedAction];
  this.actionApplied = true;
  this.stateClear = true;
  select.close();
}

/* Handles applying the currently selected tenant from the dropdown or list */
applyTenantSelection(select: any): void {
  this.selectedTenant = [...(this.tempSelectedTenant || [])];
  this.dataListTenant = [...this.selectedTenant];
  this.tenantApplied = true;
  this.stateClear = true;
  select.close();
}

/* Handles applying the currently selected status from the dropdown or list */
applyStatusSelection(select: any): void {
  this.selectedStatus = [...(this.tempSelectedStatus || [])];
  this.dbStatusList = [...this.selectedStatus];
  this.statusApplied = true;
  this.stateClear = true;
  select.close();
}

/* Checks if there is any selection made */
hasAnySelection(): boolean {
  return (
    this.stateClear ||
    this.dataListInitiate?.length > 0 ||
    this.dataListAction?.length > 0 ||
    this.dataListTenant?.length > 0 ||
    this.dbStatusList?.length > 0
  );
}

/* Closes the side navigation panel */
  closeSideNav(){
    this.sidenavService.closeRightSidenav();
  }
  
  /**
   * Resets the selected column filtering
   */
  resetFilterColumn(): void {
    if (this.name === 'Audit Dashboard') {
       if (this.tenant) {
      this.tenant.forEach(item => item.selected = false);
    }
    this.dataListTenant = [];

     if (this.status) {
      this.status.forEach(item => item.selected = false);
    }
    this.dbStatusList = [];
    this.dataListStatus = '';

    if (this.action) {
      this.action.forEach(item => item.selected = false);
    }
    this.dataListAction = [];

    if (this.initiatedBy) {
      this.initiatedBy.forEach(item => item.selected = false);
    }
    this.dataListInitiate = [];

    this.selectedUser = [];
    this.tempSelectedUser = [];
    this.selectedAction = [];
    this.tempSelectedAction = [];
    this.selectedTenant = [];
    this.tempSelectedTenant = [];
    this.selectedStatus = [];
    this.tempSelectedStatus = [];
    this.selected = [];
    this.applyFilter('reset');
    }
  }

  /* Configures the available column filter items */
  private configureColumnFilterItems(resetFilter): void {
    this.columnFilterItems = this.allColumns
    .map(column => ({
        item: column,
        label: translate('INSTANCE_STATUS.' + column),
        selected: resetFilter ? true : this.filteredColumns.includes(column),
    } as FilterItem<string>));
  }
}
